import { Badge } from '@/components/ui/shadcn/badge';
import { useTranslations } from '@/hooks/useTranslations';
import { cn } from '@/lib/utils';

interface TypeBadgeProps {
    type?: string | null;
    className?: string;
    types?: Array<{ value: string; label: string; color: string; icon?: string }>;
}

export function TypeBadge({ type, className, types }: TypeBadgeProps) {
    if (!type) return null;
    const { t } = useTranslations(); // eslint-disable-line react-hooks/rules-of-hooks
    const typeConfig: Record<string, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }> = {
        warranty: { label: t('work_orders.show.type.warranty', 'Warranty'), variant: 'default' },
        'post warranty': { label: t('work_orders.show.type.post_warranty', 'Post warranty'), variant: 'secondary' },
        contract: { label: t('work_orders.show.type.contract', 'Contract'), variant: 'outline' },
        'no work type': { label: t('work_orders.show.type.no_work_type', 'No work type'), variant: 'outline' },
    };

    // Try to find type in dynamic data
    const dynamicType = types?.find((t) => t.value === type || t.value.toLowerCase() === type.toLowerCase());

    if (dynamicType) {
        // Use dynamic data with color classes from settings
        return (
            <Badge variant="outline" className={cn('', dynamicType.color, className)}>
                {dynamicType.icon && <span className="mr-1">{dynamicType.icon}</span>}
                {dynamicType.label}
            </Badge>
        );
    }

    // Fall back to hardcoded config
    const config = typeConfig[type.toLowerCase()] || { label: type, variant: 'outline' as const };

    return (
        <Badge variant={config.variant} className={cn('capitalize', className)}>
            {config.label}
        </Badge>
    );
}
